// extracted by mini-css-extract-plugin
export default {"MainBtn":"button_MainBtn__n5Kbi"};